import { shortHash } from "./formatters";

export const policyLabels = {};
export const roleLabels = {};

export function labelForPolicy(id) {
  if (!id) return "";
  return policyLabels[id] || shortHash(id);
}

export function labelForRole(id) {
  if (!id) return "";
  return roleLabels[id] || shortHash(id);
}
